module.exports = __webpack_public_path__ + "img/self.f8a5a3a7.webp";